const reportsRoutes = [
  {
    path: "/reports",
    name: "reports",
    component: () => import("@/views/reports/Reports")
  }
];

export default reportsRoutes;
